import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis'
import axios from 'axios';

export const downloadSTNDetails = createAsyncThunk('downloadSTNDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/download-iwit-stn`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = `invoice_${data.invoice_number}_stn_details.pdf`;
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
    }
});